<template>
    <div class="text-center">
        <v-dialog persistent v-model="$store.getters.newIssueDialog" width="700">

            <v-card>
                <v-card-title class="white--text primary">
                    <h4 class="white--text primary" >Ερώτηση προς Γραφείο Αρωγής</h4>
                    <v-spacer></v-spacer>
                    <v-icon @click="closeDialog" color="white">close</v-icon>
                </v-card-title>

                <v-card-text>
                    <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                        <v-flex xl10 >

                            <v-form ref="form" v-model="valid">
                                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                                    <v-flex xl10 lg10 md5>
                                        <v-text-field v-model="name" label="Ονοματεπώνυμο" :rules="[utils.requiredRuleTextbox]"/>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                                    <v-flex xl5 lg5 md5 class=" mr-1">
                                        <v-text-field label="Τηλέφωνο" v-model="phone" :rules="[utils.phoneRulesRequired, utils.phoneRules]"/>
                                    </v-flex>

                                    <v-flex xl5 lg5 md5 class=" ml-1">
                                        <v-text-field label="E-mail" v-model="email" :rules="[utils.requiredRuleTextbox, utils.emailRules]"/>
                                    </v-flex>
                                </v-layout>


                                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                                    <v-flex xl10 lg10 md5>
                                        <v-combobox readonly :value="userType"
                                                      item-text="text" return-object
                                                      label="Είδος Χρήστη"/>

                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                                    <v-flex xl10 lg10 md5>
                                        <v-combobox v-model="issueType"
                                                  :items="issueTypeItems"
                                                  item-text="text" :rules="[utils.selectboxRequired]"
                                                  label="Είδος αναφοράς"
                                                  return-object/>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                                    <v-flex xl10 lg10 md5>
                                        <v-textarea outline
                                                name="input-7-4"
                                                label="Κείμενο"
                                                v-model="text" :rules="[utils.requiredRuleTextbox]"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                                    <v-flex xl5 lg5 md5>
                                        <v-btn @click="createNewIssue" :disabled="!valid" outline block color="primary" style="border-width: 2px">
                                            ΑΠΟΣΤΟΛΗ
                                            <v-icon color="primary" class=" ml-1">mdi-send</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>

                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import requests from "../../requests";
    import utils from "../../utilities";
	export default {
		name: "NewIssueDialog",
        props:{
			dialogKey: Number
        },
		data: () => ({
			// This map exists only as a reference. It's unused
			issueTypesMap: {
				78: 'Γενικές πληροφορίες',
				79: 'Θέματα πρόσβασης',
				10702: 'Έλεγχος Δηλώσεων',
				10708: 'Πιστοποίηση',
				80: 'Μεταβολή στοιχείων',
				11: 'Παράπονα',
				10701: 'Εισαγωγή Συγγράμματος',
				10703: 'Εξαγωγή Στοιχείων',
				10707: 'Καταχώριση Μαθημάτων/Συγγραμμάτων',
				10704: 'Θέματα Επιστροφών',
				10705: 'Θέματα Παραγγελιών',
				10700: 'Απώλεια PIN',
				10706: 'Θέματα Παραλαβής Συγγραμμάτων',
			},
            issueTypeItems:[
	            {id: 79, text: 'Θέματα πρόσβασης'},
	            {id: 10700, text: 'Απώλεια PIN'},
	            {id: 10702, text: 'Έλεγχος Δηλώσεων'},
	            {id: 10706, text: 'Θέματα Παραλαβής Συγγραμμάτων'},
	            {id: 11, text: 'Παράπονα'},
            ],
			userType: {id: 12727, text: 'Φοιτητής', role: 'student'},
			valid:false,
			name: '',
			phone: '',
			email: '',
			text: '',
			issueType: {},
        }),


      computed: {
            utils() {
              return utils
            },

        },

		methods: {

			closeDialog() {
                this.$store.commit('setNewIssueDialog', false);
			},

            createNewIssue(){
                this.$store.commit('setLoadingModal', true);
                let reqObj = {
	                name: this.name,
	                phone: this.phone,
	                email: this.email,
	                issueText: this.text,
	                issueTypeId: this.issueType.id,
                };

                requests.post('student/api/student/ticket', reqObj,  (resp) =>{
                  this.$store.commit('setLoadingModal', false);
                  this.$store.commit('setNewIssueDialog', false);
                  this.$emit('refresh-issues', resp);
                  let message = {
                    title: 'Επικοινωνία με γραφείο αρωγής',
                    message: 'Το μήνυμα στάλθηκε επιτυχώς.',
                    close: true
                  };
                  this.$store.commit('setMessageObject', message);
                  this.$store.commit('setMessageModal', true);
                });
            },
        },

		watch: {
			dialogKey() {
				this.name = this.$store.getters.login.firstname + ' ' + this.$store.getters.login.lastname;
                this.phone = this.$store.getters.login.mobile;
                this.email = this.$store.getters.login.personalEmail;
                this.text = '';
                this.issueType = null;
				this.$refs.form.resetValidation();
			}
		},
	}
</script>

<style scoped>

</style>